<template>
  <el-form :model="serialForm" status-icon :rules="rules" ref="serialForm" class="demo-serialForm" label-width="9%">
    <el-row><br></el-row>
    <el-form-item :label="this.$t('serialReport.projectCode', { msg: 'serialReport.projectCode' })">
    <el-col :span="11">
      <el-form-item prop="projectFrom">
        <el-input v-model="serialForm.projectFrom"></el-input>
      </el-form-item>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp;{{ $t('serialReport.to', { msg: 'serialReport.to' }) }}&nbsp;&nbsp;&nbsp;</el-col>
    <el-col :span="11">
      <el-form-item prop="projectTo">
        <el-input v-model="serialForm.projectTo"></el-input>
      </el-form-item>
    </el-col>
  </el-form-item>
    <el-form-item :label="this.$t('serialReport.itemCode', { msg: 'serialReport.itemCode' })">
    <el-col :span="11">
      <el-form-item prop="itemCodeFrom">
        <el-input v-model="serialForm.itemCodeFrom"></el-input>
      </el-form-item>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp;{{ $t('serialReport.to', { msg: 'serialReport.to' }) }}&nbsp;&nbsp;&nbsp;</el-col>
    <el-col :span="11">
      <el-form-item prop="itemCodeTo">
        <el-input v-model="serialForm.itemCodeTo"></el-input>
      </el-form-item>
    </el-col>
  </el-form-item>
  <el-form-item :label="this.$t('serialReport.serialNumber', { msg: 'serialReport.serialNumber' })">
    <el-col :span="11">
      <el-form-item prop="serialNoFrom">
        <el-input v-model="serialForm.serialNoFrom"></el-input>
      </el-form-item>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp;{{ $t('serialReport.to', { msg: 'serialReport.to' }) }}&nbsp;&nbsp;&nbsp;</el-col>
    <el-col :span="11">
      <el-form-item prop="serialNoTo">
        <el-input v-model="serialForm.serialNoTo"></el-input>
      </el-form-item>
    </el-col>
  </el-form-item>
  <el-form-item :label="this.$t('serialReport.salesOrderNumber', { msg: 'serialReport.salesOrderNumber' })">
    <el-col :span="11">
      <el-form-item prop="salesOrderNoFrom">
        <el-input v-model="serialForm.salesOrderNoFrom"></el-input>
      </el-form-item>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp;{{ $t('serialReport.to', { msg: 'serialReport.to' }) }}&nbsp;&nbsp;&nbsp;</el-col>
    <el-col :span="11">
      <el-form-item prop="salesOrderNoTo">
        <el-input v-model="serialForm.salesOrderNoTo"></el-input>
      </el-form-item>
    </el-col>
  </el-form-item>
  <el-form-item :label="this.$t('serialReport.deliveryDate', { msg: 'serialReport.deliveryDate' })">
    <el-col :span="11">
      <el-form-item prop="deliveryDateFrom">
        <el-input v-model="serialForm.deliveryDateFrom"></el-input>
      </el-form-item>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp;{{ $t('serialReport.to', { msg: 'serialReport.to' }) }}&nbsp;&nbsp;&nbsp;</el-col>
    <el-col :span="11">
      <el-form-item prop="deliveryDateTo">
        <el-input v-model="serialForm.deliveryDateTo"></el-input>
      </el-form-item>
    </el-col>
  </el-form-item>
  <el-form-item :label="this.$t('serialReport.invoiceNumber', { msg: 'serialReport.invoiceNumber' })">
    <el-col :span="11">
      <el-form-item prop="invoiceNoFrom">
        <el-input v-model="serialForm.invoiceNoFrom"></el-input>
      </el-form-item>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp;{{ $t('serialReport.to', { msg: 'serialReport.to' }) }}&nbsp;&nbsp;&nbsp;</el-col>
    <el-col :span="11">
      <el-form-item prop="invoiceNoTo">
        <el-input v-model="serialForm.invoiceNoTo"></el-input>
      </el-form-item>
    </el-col>
  </el-form-item>
  <el-form-item :label="this.$t('serialReport.invoiceDate', { msg: 'serialReport.invoiceDate' })">
    <el-col :span="11">
      <el-form-item prop="invoiceDateFrom">
        <el-input v-model="serialForm.invoiceDateFrom"></el-input>
      </el-form-item>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp;{{ $t('serialReport.to', { msg: 'serialReport.to' }) }}&nbsp;&nbsp;&nbsp;</el-col>
    <el-col :span="11">
      <el-form-item prop="invoiceDateTo">
        <el-input v-model="serialForm.invoiceDateTo"></el-input>
      </el-form-item>
    </el-col>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" icon="el-icon-upload2" @click="submitForm('serialForm')">{{ $t('serialReport.printBtn', { msg: 'serialReport.printBtn' }) }}</el-button>
    <el-button @click="resetForm('serialForm')">{{ $t('serialReport.resetBtn', { msg: 'serialReport.resetBtn' }) }}</el-button>
  </el-form-item>
  </el-form>
</template>

<script>
  import { baseUrl_New } from '../../axios/urlconfig';
  import axios from 'axios';
  
 
export default {
  data() {
      return {
        serialForm: {
          projectFrom: '',
          projectTo: '',
          deliveryDateFrom: '',
          deliveryDateTo: '',
          invoiceDateFrom: '',
          invoiceDateTo: '',
          invoiceNoFrom: '',
          invoiceNoTo: '',
          itemCodeFrom: '',
          itemCodeTo: '',  
          salesOrderNoFrom: '',
          salesOrderNoTo: '',
          serialNoFrom: '',
          serialNoTo: '',
        },
        rules: {
          // projectFrom: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // projectTo: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // deliveryDateFrom: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // deliveryDateTo: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // invoiceDateFrom: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // invoiceDateTo: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // invoiceNoFrom: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // invoiceNoTo: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // itemCodeFrom: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // itemCodeTo: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // salesOrderNoFrom: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // salesOrderNoTo: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // serialNoFrom: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
          // serialNoTo: [
          //   { required: false, message: '请输入', trigger: 'blur' },
          // ],
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
        let itemF = '';
        let itemT = '';
        if(this.serialForm.itemCodeFrom != null && this.serialForm.itemCodeFrom != ''){
          itemF = this.serialForm.itemCodeFrom.match(/\d/g).join('');
        }
        if(this.serialForm.itemCodeTo != null && this.serialForm.itemCodeTo != ''){
          itemT = this.serialForm.itemCodeTo.match(/\d/g).join('');
        }
          const params =  {
          "t_item_f": itemF,
          "t_item_t": itemT,
          "t_orto_f": this.serialForm.salesOrderNoFrom,
          "t_orto_t": this.serialForm.salesOrderNoTo,
          "t_proj_f": this.serialForm.projectFrom,
          "t_proj_t": this.serialForm.projectTo,
          "t_sern_f": this.serialForm.serialNoFrom,
          "t_sern_t": this.serialForm.serialNoTo,
          "t_usf1_f": this.serialForm.deliveryDateFrom,
          "t_usf1_t": this.serialForm.deliveryDateTo,
          "t_usf2_date_f": this.serialForm.invoiceDateFrom,
          "t_usf2_date_t": this.serialForm.invoiceDateTo,
          "t_usf2_no_f": this.serialForm.invoiceNoFrom,
          "t_usf2_no_t": this.serialForm.invoiceNoTo,
          "t_proj_len": this.serialForm.projectFrom.length
        }
        axios.post(baseUrl_New + '/report/export', params,{
      responseType: 'blob'  // 指定响应类型为 Blob
      }
        ).then(resp=>{
          // console.log(resp);
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const a = document.createElement('a');
          a.href = url;
          a.download = 'report.xlsx';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }).catch(err => {
          this.$message.error(err);
        })
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    }

}
</script>

<style>

</style>